import { Component, OnInit } from '@angular/core';
import { IacctRange } from 'src/app/shared/models/models';
import { IacctService } from './iacct.service';

@Component({
  selector: 'app-iact',
  templateUrl: './iact.component.html',
  styleUrls: ['./iact.component.css'],
})
export class IactComponent implements OnInit {
  iacctRanges: IacctRange[] = null;
  constructor(private readonly iacctService: IacctService) {}

  ngOnInit(): void {
    this.updateIacctRanges();
  }

  updateIacctRanges() {
    this.iacctService.getIacctRanges().subscribe((iacctRanges) => (this.iacctRanges = iacctRanges));
  }
}
